import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import taggingPremiumIcon from '../../assets/images/icons/tagging_premium.svg';
import taggingBlacklistIcon from '../../assets/images/icons/tagging_blacklist.svg';
import taggingGoodIcon from '../../assets/images/icons/tagging_good.svg';
import taggingLowIcon from '../../assets/images/icons/tagging_low.svg';
import taggingBlockedIcon from '../../assets/images/icons/tagging_blocked.svg';
import taggingDirectIcon from '../../assets/images/icons/tagging_direct.svg';
import taggingNoTagIcon from '../../assets/images/icons/tagging_notag.svg';
import { saveAs } from "file-saver";
import { notifyfailure, notifysuccess } from "../../utils/toast";
import mediaKitIcon from '../../assets/images/icons/download_gray_icon.svg';

const AdminTagList = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    // const [colvis, setColvis] = useState({
    //     "z_cate": true,
    //     "invent_type": true,
    //     "p_name": true,
    //     "createdAt": true
    // })

    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            width: 50,
            fixed: 'left',
            render: (text, record) => {
                return (

                    <div className='btn_group'

                    >
                        {record?.downloadLoading ?

                            <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                                <span> Download</span>
                                <img src={FullLoader} alt="USP" className="" />
                            </button>
                            :
                            <Tooltip title="Download">
                                <button className='download_icon download_icon_d2'
                                    onClick={() => {
                                        handleDownload(record._id, record.name)
                                    }}
                                >
                                    <img src={mediaKitIcon} alt='USP' />
                                </button>
                            </Tooltip>
                        }
                    </div>
                )
            },
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 95,
            fixed: 'left',
            render: (text) => {
                return (
                    <>

                        {text === "Processed" ?
                            <button className='badge_content_fixed--approved'>
                                {text}
                            </button>
                            :
                            <button className='badge_content_fixed--declined'> {text}</button>
                        }

                    </>
                )
            }
        },


        {
            title: "Name",
            dataIndex: "name",
            width: 250,
            key: "name",
            fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                return (
                    <div >
                        {(text === "" || text === undefined || text === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {((text?.length || 0)) >= 35 ? (
                                    <Tooltip title={text}>
                                        {text?.slice(0, 35)} ...
                                    </Tooltip>
                                ) : (
                                    <>{text}</>
                                )}
                            </>

                        }
                    </div>
                )
            },
        },
        {
            title: "Tag",
            dataIndex: "tag",
            width: 100,
            key: "tag",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                return (
                    <div className="d-flex gap_8">

                        <>
                            {
                                text === "Premium" ?

                                    <img src={taggingPremiumIcon} alt="" />

                                    :
                                    text === "Good" ?

                                        <img src={taggingGoodIcon} alt="" />

                                        :
                                        text === "Low" ?

                                            <img src={taggingLowIcon} alt="" />

                                            :
                                            text === "Blacklist" ?

                                                <img src={taggingBlacklistIcon} alt="" />

                                                :
                                                text === "Blocked" ?

                                                    <img src={taggingBlockedIcon} alt="" />

                                                    :
                                                    text === "Direct" ?

                                                        <img src={taggingDirectIcon} alt="" />

                                                        :

                                                        <img src={taggingNoTagIcon} alt="" />

                            }
                        </>
                        <>{text}</>
                    </div>
                )
            }
        },
        {
            title: "Uploaded By",
            dataIndex: "uploadedBy",
            width: 180,
            key: "uploadedBy",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 150,
            key: "createdAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Updated At",
            dataIndex: "updatedAt",
            width: 150,
            key: "updatedAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Acknowledged",
            dataIndex: "acknowledged",
            width: 100,
            key: "acknowledged",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Modified Count",
            dataIndex: "modified",
            width: 100,
            key: "modified",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Matched Count",
            dataIndex: "matched",
            width: 100,
            key: "matched",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },

    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const handleDownload = async (id, name) => {


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `adsTxt/downloadDomain?type=tag&_id=` + id,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, name + ".csv");
                })
                .catch((error) => { });
        }
    };


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `adstxt/domainTagList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        // let checkRole = jwtDecode(token).role;
        // setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };

    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Tagging History
                    </h1>
                </div>
                <div className="d_flex justify_content_between  mb_10">
                    <div className="form_content_block--group">
                        {!initialLoad &&
                            <Input
                                type='text'
                                className='form_control basic md search_input w_table_search'
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {

                                    if (e.target.value.trim().length === 0) {
                                        setLoading(true)
                                    }

                                    setSearch(e.target.value)
                                }}
                            />
                        }
                    </div>
                    {/* <div className="custom_filter_design_d2">


                        <div className="column_hide_unhide_d2">
                            <Dropdown className="" autoClose="outside">
                                <Dropdown.Toggle id="dropdown-autoclose-outside">
                                    <img src={columnIcon} alt="" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className="colunm_checkbox">
                                        <ul className="p-0 m-0">

                                            <li>
                                                <label htmlFor="oneone">
                                                    <input className="form-check-input" type="checkbox" id="oneone"
                                                        checked={colvis.z_cate}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.z_cate = !tempData.z_cate
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Category</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="twotwo">
                                                    <input className="form-check-input" type="checkbox" id="twotwo"
                                                        checked={colvis.invent_type}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.invent_type = !tempData.invent_type
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Inventory Type</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="three">
                                                    <input className="form-check-input" type="checkbox" id="three"
                                                        checked={colvis.p_name}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.p_name = !tempData.p_name
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Publisher</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="four">
                                                    <input className="form-check-input" type="checkbox" id="four"
                                                        checked={colvis.createdAt}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.createdAt = !tempData.createdAt
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Created At</span>
                                                </label>
                                            </li>

                                        </ul>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div> */}

                </div>
                <div className="table_content--box table_empty_screen_d2">
                    {loading && !initialLoad &&
                        <div className="table_new_loader_d2">
                            <img src={FullLoader} className="img-fluid" alt="" />
                        </div>
                    }

                    {initialLoad ?
                        <TableLoader />

                        :
                        <Table
                            columns={columnsAll}
                            pageSize={100}
                            dataSource={data}
                            onChange={handleTableChange}
                            pagination={false}
                            rowKey={(record) => record.id}
                            locale={locale}
                            scroll={{ x: 1500, y: 'calc(100vh - 27rem' }} />


                    }

                    {data.length > 0 &&
                        <Row className="custom_pagination--container">
                            <Col span={6}>
                                <div className="form_content_block--group mb_0">
                                    <Select
                                        className='form_select basic sm no_search'
                                        value={page.pageSize}
                                        onChange={handlePageSizeChange}
                                        style={{ width: 80 }}
                                        showSearch={false}
                                        options={[
                                            { value: 10, label: 10 },
                                            { value: 20, label: 20 },
                                            { value: 50, label: 50 },
                                            { value: 100, label: 100 },
                                        ]} />
                                    <label className='custom_pagination--label'>
                                        items per page
                                    </label>
                                </div>
                            </Col>
                            <Col span={6}>
                                <span className="custom_pagination--total-text">
                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                </span>
                            </Col>
                            <Col span={6}>
                                <Pagination
                                    current={page.current}  // Pass individual props instead of spreading them
                                    pageSize={page.pageSize}
                                    total={page.total}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                    itemRender={itemRender}
                                    className="custom_pagination" />
                            </Col>
                        </Row>
                    }
                </div>
            </div>
        </>
    );
};

export default AdminTagList;
